import { StatusCodes } from 'http-status-codes';
import { CustomError } from 'ts-custom-error';

import type { ErrorCodes } from '@reach/interfaces/error/error-codes.enum';

import type { AppErrorParams } from './app-error-params.type';

export class AppError extends CustomError implements AppErrorParams {
	public id: string;
	public status: StatusCodes;
	public code: ErrorCodes;
	public title: string;
	public detail: string;
	public meta: Record<string, unknown>;

	constructor({
		id,
		status,
		code,
		title,
		detail,
		meta,
		cause,
	}: Partial<AppErrorParams> & Required<Pick<AppErrorParams, 'code'>> & { cause?: unknown }) {
		super(title, { cause });
		const bunRandomUuid = (globalThis as unknown as { Bun?: { randomUUIDv7?: () => string } })
			.Bun?.randomUUIDv7;
		this.id =
			id ?? (typeof bunRandomUuid === 'function' ? bunRandomUuid() : crypto.randomUUID());
		this.status = status ?? StatusCodes.INTERNAL_SERVER_ERROR;
		this.code = code;
		this.title = title ?? 'An error has occurred.';
		this.detail = detail ?? 'Please contact support.';
		this.meta = meta ?? {};
	}

	public toPayload(): AppErrorParams {
		const { id, status, code, title, detail, meta } = this;
		return { id, status, code, title, detail, meta };
	}
}
